// Nome legível dos arquivos escolhidos por atalho (0.53).
// No Android, alguns lugares (Galeria, Google Drive) não mostram o nome do arquivo no endereço
// (ex.: "image:249069"). Aí o app usa um nome claro: "Imagem 08-10-2026 19h00.jpg".
import { t } from './i18n';
import type { Anexo } from '../store/types';

const p2 = (n: number) => String(n).padStart(2, '0');
const tipoDe = (mime?: string) => (!mime ? t('Arquivo') : mime.startsWith('image/') ? t('Imagem') : mime.startsWith('video/') ? t('Vídeo')
  : mime.startsWith('audio/') ? t('Áudio') : mime === 'application/pdf' ? 'PDF' : /sheet|excel|csv/.test(mime) ? t('Planilha')
  : /word|document|msword/.test(mime) ? t('Documento') : /presentation|powerpoint/.test(mime) ? t('Apresentação') : t('Arquivo'));
const EXT: Record<string, string> = { 'application/pdf': 'pdf', 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/heic': 'heic',
  'video/mp4': 'mp4', 'audio/mpeg': 'mp3', 'text/csv': 'csv', 'text/plain': 'txt',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx' };

/** O nome veio sem informação (só um código)? */
export const nomeSemSentido = (n: string) => !n || /^[a-z_]+:\d+$/i.test(n) || /^\d+$/.test(n) || /[;=]/.test(n) || /^(msf|raw|document|acc)[:=]/i.test(n);

/** Nome a partir do endereço do arquivo; se não houver nome de verdade, monta um com o tipo e a data. */
export function nomeLegivel(bruto: string, mime?: string, quando = new Date(), n = 0) {
  let s = bruto || '';
  try { s = decodeURIComponent(s); } catch { /* fica como veio */ }
  s = s.split('/').pop() || '';
  if (s.includes(':') && !nomeSemSentido(s)) s = s.slice(s.lastIndexOf(':') + 1);
  if (!nomeSemSentido(s) && /\.[a-z0-9]{2,5}$/i.test(s)) return s;
  const ext = mime ? EXT[mime] ?? '' : '';
  const d = quando;
  return `${tipoDe(mime)} ${p2(d.getDate())}-${p2(d.getMonth() + 1)}-${d.getFullYear()} ${p2(d.getHours())}h${p2(d.getMinutes())}${n ? ` (${n + 1})` : ''}${ext ? '.' + ext : ''}`;
}

/** Nome para mostrar de um anexo (os antigos com código viram "Imagem 249069"). */
export function nomeAnexo(a: Pick<Anexo, 'nome' | 'mime'>) {
  const n = a.nome || '';
  const m = /^[a-z_]+:(\d+)$/i.exec(n);
  if (m) return `${tipoDe(a.mime ?? (n.startsWith('image') ? 'image/*' : n.startsWith('video') ? 'video/*' : undefined))} ${m[1]}`;
  return n || t('Arquivo');
}
